import type { GridElement } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import type { VideoEmbedPropsApi } from '@/features/grid/videoEmbed/models'
import VimeoEmbed from '@/features/grid/videoEmbed/subcomponents/VimeoEmbed'
import YoutubeEmbed from '@/features/grid/videoEmbed/subcomponents/YoutubeEmbed'

export const VideoEmbed: FC<GridElement<VideoEmbedPropsApi>> = props => {
    const {
        value: { url },
    } = props

    const isYoutube = url.includes('youtube.com')
    const isVimeo = url.includes('vimeo.com')

    return (
        <>
            {isYoutube && <YoutubeEmbed {...props.value} />}
            {isVimeo && <VimeoEmbed {...props.value} />}
        </>
    )
}

VideoEmbed.displayName = 'VideoEmbed'
